/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_Hidden_No_VariantsInputs */

const vi_shop_group_hidden_no_variants = /** @type {(inputs: Shop_Group_Hidden_No_VariantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa hiển thị: thiếu loại`)
};

/**

* @param {Shop_Group_Hidden_No_VariantsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_hidden_no_variants = /** @type {((inputs?: Shop_Group_Hidden_No_VariantsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Hidden_No_VariantsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_hidden_no_variants(inputs)
});